import { render, staticRenderFns } from "./reaction_picker.vue?vue&type=template&id=21494202&"
import script from "./reaction_picker.vue?vue&type=script&lang=js&"
export * from "./reaction_picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports